<template>
    <div
        :class="classObject"
        v-click-outside="close"
        @keyup.esc="close"
    >
        <a
            href="#"
            class="z-dropdown__trigger"
            @click.prevent="toggle"
        >
            <slot name="trigger"></slot>
        </a>
        <div v-show="isOpen" class="z-dropdown__content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'z-dropdown',
    props: {
        theme: {
            type: String
        }
    },
    data: function () {
        return {
            isOpen: false
        }
    },
    methods: {
        toggle () {
            this.isOpen = !this.isOpen
        },
        close () {
            this.isOpen = false
        }
    },
    computed: {
        classObject () {
            let arrClass = [
                'z-dropdown',
                {
                    'is-opened': this.isOpen
                }
            ]

            if (this.theme) {
                arrClass.push(`z-dropdown--theme-${this.theme}`)
            }

            return arrClass
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
